"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.balanceColumn = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../utils/classFunctions");
const roundMoney_1 = require("../../../../utils/roundMoney");
require("./index.scss");
const className = 'balance-column';
const balanceColumn = (options) => {
    var _a;
    return ({
        Header: (_a = options === null || options === void 0 ? void 0 : options.Header) !== null && _a !== void 0 ? _a : (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Table/Column:Balance', defaultMessage: 'Balance' })),
        id: 'balance',
        disableSortBy: options === null || options === void 0 ? void 0 : options.disableSortBy,
        Cell: ({ row }) => {
            const { balance = 0 } = row.original;
            const classNames = (0, classFunctions_1.getClassNames)(className, [
                balance > 0 ? 'positive' : undefined,
                balance < 0 ? 'negative' : undefined,
            ]);
            const { locale } = (0, react_intl_1.useIntl)();
            return (react_1.default.createElement("span", { className: classNames },
                (0, roundMoney_1.localizeMoney)(balance, locale, 'Table/columns/balanceColumn'),
                " CHF"));
        },
    });
};
exports.balanceColumn = balanceColumn;
//# sourceMappingURL=index.js.map